import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';

import { useTranslation } from "react-i18next";

const HeatMap = ({ chartData, kpiname }) => {

  const [t] = useTranslation('common');

  const chartRef = useRef();
  //const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {

    let formatted = { kpi: 'distance', data: chartData[0].data }

    let uniqueID = [...new Set(chartData[0].data.map(item => item.y))];
    let uniqueDate = [...new Set(chartData[0].data.map(item => item.x))];
    let uniqueVals = [...new Set(chartData[0].data.map(item => item.z))];

    let idLength = uniqueID[0].length

    const data = formatted.data;

    // Color scale
    let colorScale = d3.scaleSequential()
      .domain([0, d3.max(uniqueVals)])
      .interpolator(d3.interpolate("white", "#4d0077"));


    // Chart dimensions
    const width = uniqueDate.length * 20,
      height = (uniqueID.length * 20),
      margins = { top: 100, right: 50, bottom: 150, left: 17 * idLength };


    //X and Y scale
    let ordinalScaleX = d3.scaleOrdinal()
      .domain(data.map((e) => {
        return (e.x);
      }))
      .range(uniqueDate.map((e, i) => {
        return i * 20
      }));

    let ordinalScaleY = d3.scaleOrdinal()
      .domain(data.map((e) => {
        return (e.y);
      }))
      .range(uniqueID.map((e, i) => {
        return i * 20
      }));


    //Setting chart width and adjusting for margins
    const chart = d3.select(chartRef.current)
      .attr('width', width + margins.right + margins.left)
      .attr('height', height + margins.top + margins.bottom)
      .append('g')
      .attr('transform', 'translate(' + margins.left + ',' + margins.top + ')');


    //Create tooltip
    const tooltip = d3.select('.container').append('div')
      .attr('class', 'tooltip')
      .html('Tooltip')
      .attr('id', 'tooltipid')


    //Append heatmap bars, styles, and mouse events
    const barWidth = 20,
      barHeight = 20;

    chart.selectAll('g')
      .data(data).enter().append('g')
      .append('rect')
      .attr('x', d => { return (uniqueDate.indexOf(d.x)) * barWidth })
      .attr('y', d => { return (uniqueID.indexOf(d.y)) * barHeight })
      .style("fill", d => colorScale(d.z))
      .attr('width', barWidth)
      .attr('height', barHeight)
      .attr("rx", 4)
      .attr("ry", 4)
      .on('mouseover', d => {
        chart.mouse = d3.pointer(d);
        chart.mouse2 = d3.pointer(d, d3.select(chart.chartLocation));
        tooltip.html('Date : ' + d.srcElement.__data__.x + '<br/>' +
          t('vehdays.hover.veh') + d.srcElement.__data__.y + '<br/>' +
          kpiname + ' : ' + d.srcElement.__data__.z.toFixed(0))
          .style('left', chart.mouse2[0] - 50 + 'px')
          .style('top', chart.mouse2[1] - 100 + 'px')
          .style('opacity', .9);
      }).on('mouseout', () => {
        tooltip.style('opacity', 0)
          .style('left', '0px');
      }).on("mouseleave", () => {
        tooltip.style('opacity', 0)
          .style('left', '0px');
      })


    //Append x axis
    chart.append('g')
      .attr('transform', 'translate(10,' + 0 + ')')
      .call(d3.axisTop(ordinalScaleX))
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "6em")
      .attr("dy", "1em")
      .attr("transform", "rotate(-90)")
      .attr("font-family", "Roboto")
      .style("font-size", "13px")


    //Append y axis
    chart.append('g')
      .attr('transform', 'translate(0,+' + barHeight / 2 + ')')
      .call(d3.axisLeft(ordinalScaleY))
      .attr('class', 'yAxis')
      .attr("font-family", "Roboto")
      .style("font-size", "13px")


    //Append y axis label
    chart.append('text')
      .attr('transform', 'translate(' + (-14 * idLength) + ',' + (height / 2) + ') rotate(-90)')
      .style('text-anchor', 'middle')
      .text(t('vehdays.vehno'));


  }, [chartData]);


  return <svg ref={chartRef}></svg>;

};

export default HeatMap;